export const LV_ShipmentKindTR={
ShKiID:{en:'ShKiID',cs:'ShKiID',dataType:'number',format:'#0',required:true},
ShKiName:{en:'Name',cs:'Název',dataType:'string',required:true,maxLength:255}
}